<script lang="typescript">
    import CaretDown from "./icons/caret-down.svelte";
    import { slide } from "svelte/transition";
    export let header = "Header";
    export let expand = false;
    export let style = "";
    export let mode: "switch" | "hide" = "switch";
    export let color = "var(--color-level-8)";
    export let headerStyle = "";
    const toggle = () => {
        expand = !expand;
    };
</script>

<div class="expander" {style}>
    <div class="expander-header" style={headerStyle} on:click={toggle}>
        <span class="title" style="color: {color};">{header}</span>
        <div class:iconShow={expand} class="icon">
            <svelte:component this={CaretDown} width={24} height={24} color="var(--color-level-8)" />
        </div>
        <slot name="expander-icon" />
    </div>

    {#if mode === "switch" && expand}
        <slot />
    {/if}

    {#if mode === "hide"}
        <div class="expander-content" class:expand>
            <slot />
        </div>
    {/if}
</div>

<style>
    .expander {
        width: 100%;
    }
    .expander-header {
        height: 48px;
        width: 100%;
        display: flex;
        flex-shrink: 0;
        padding: 16px 24px;
        font-size: 14px;
        align-items: center;
        cursor: pointer;
        background: var(--color-level-2);
        justify-content: space-between;
    }
    .expander-content {
        display: none;
    }
    .expand {
        display: block;
    }

    .icon {
        transform: rotate(-90deg);
        transition: transform 0.3s ease-in-out;
        width: 24px;
        height: 24px;
    }

    .iconShow {
        transform: rotate(0deg);
    }
</style>
